<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Maestro de Usuarios</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.imagen="{ item }">
              <v-avatar size="32">
                <img :src="item.imagen_usuario.length > 10 ? item.imagen_usuario : api+'uploads/default-user-image.png'" alt="img">
              </v-avatar>
            </template>

            <template v-slot:item.estado="{ item }">
              {{item.estado==1 ? 'Activo' : 'Inactivo'}}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
              <v-card-actions>
                <v-btn dark color="blue" @click="cargaMasiva">Carga Masiva</v-btn>
              
              <v-spacer></v-spacer>
              
                <v-btn dark color="success" @click="exportExcel(datos)"><v-icon>mdi-file-excel-box</v-icon> Exportar</v-btn>
              </v-card-actions>              
    </v-card>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedItem.nombres }} {{ editedItem.apellidos }}</span>
          <v-spacer></v-spacer>
          <v-switch :label="editedItem.estado ? 'Activo' : 'Inactivo'" v-model="editedItem.estado" color="success" v-if="editedIndex > -1"></v-switch>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="editedItem.nombres" label="Nombres" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="editedItem.apellidos" label="Apellidos" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="editedItem.codigo" label="Codigo" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="editedItem.cargo" label="Cargo" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="editedItem.codigo_depto" label="Cod Dpto" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="editedItem.depto" label="Departamento" required outlined></v-text-field>
              </v-col>
            
              <v-col cols="3">
                <v-text-field v-model="editedItem.grupo" label="Grupo" required outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fono" label="Telefono" required outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                 <v-autocomplete v-model="editedItem.idsupervisor" :items="personSimple" outlined label="Supervisor" ></v-autocomplete>
              </v-col>
              <v-col cols="3">
                 <v-autocomplete v-model="editedItem.idsupervisormat" :items="personSimple" outlined label="Sup Matricial" ></v-autocomplete>
              </v-col>

              <v-col cols="6">
                <v-text-field v-model="editedItem.fecnacimiento" label="Fecha Nacimiento" readonly required outlined @click="fechas('nacimiento')" ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field v-model="editedItem.fecingreso" label="Fecha Ingreso" readonly required outlined @click="fechas('ingreso')"></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field v-model="editedItem.correo" label="Correo" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select :items="niveles" v-model="editedItem.level" label="Nivel de Usuario" outlined></v-select>
              </v-col>
 
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="restablecer">Reiniciar Clave</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
      <v-dialog v-model="calendario" persistent width="290px">
        <v-date-picker v-model="date" scrollable @input="fechasave(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="calendario = false">Cancel</v-btn>
          <v-btn text color="primary" @click="fechasave(dialogofType)">OK</v-btn>
        </v-date-picker>
      </v-dialog>    
  </div>
</template>
<script>
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
import api from "../conf/ruta-base"
import store from "../store"
import router from '../router'
import XLSX from 'xlsx'
moment.locale('es')
export default {
  name: "instituciones",
  data: () => ({
    apiPath: "user", search: "", dialog: false, date: new Date().toISOString().substr(0, 10), calendario: false, api: api.api,
    headers: [
      { text: "Imagen", value: "imagen" },
      { text: "Activo", value: "estado" },
      { text: "Nombres", align: "start", sortable: true, value: "nombres" },
      { text: "Apellidos", sortable: true, value: "apellidos" },
      { text: "Usuario", value: "correo" },
      { text: "Nivel", value: "level" },
      { text: "Supervisor", value: "sup" },
      { text: "Supervisor Matricial", value: "supmat" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    datos: [],
    selec: '',
    niveles: [
        {text:'Usuario Standart',value:'usr'},
        {text:'Usuario Administrador',value:'adm'},
        ],
    instituciones:[], dialogofType: '', personSimple:[], editedIndex: -1,
    editedItem: { id: "", nombres: "", apellidos: "", codigo: "", cargo: "", codigo_depto: "", depto: "" ,fecingreso: "", fecnacimiento: "", estado: 1,
    grupo:"", fono:"",correo:"", level:"",},
    defaultItem: { id: "", nombres: "", apellidos: "", codigo: "", cargo: "", codigo_depto: "", depto: "" ,fecingreso: "", fecnacimiento: "", estado: 1,
    grupo:"", fono:"",correo:"", level:"",}
  }),
  mounted() {
    axios
      .get(api.api + this.apiPath + '/institucion')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          if(!r.data[i].sup){
            r.data[i].sup = ''
          }
          r.data[i].fecingreso = moment(r.data[i].fecha_ingreso).format('L')
          r.data[i].fecnacimiento = moment(r.data[i].fecha_nacimiento).format('L')
          this.datos.push(r.data[i])
          let person={
            value: r.data[i].id,
            text: r.data[i].nombres + ' ' + r.data[i].apellidos,
          }
          this.personSimple.push(person)
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Modificar Usuario";
    }
  },
  methods: {

    fechas(evento){
        this.dialogofType = evento;
        this.calendario = true;
    },

    fechasave(evento){
        let [year, month, day] = this.date.split('-')
        let date = day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year
        if(evento=='ingreso'){
          this.editedItem.fecingreso = date
          this.editedItem.fecha_ingreso = this.date
        }else if(evento=='nacimiento'){
          this.editedItem.fecnacimiento = date
          this.editedItem.fecha_nacimiento = this.date
        }
        this.dialogofType = ''
        this.calendario = false
        this.date = new Date().toISOString().substr(0, 10)
    },    

    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave(){
      let bandera = true
      let err = ''
        if(bandera && (this.editedItem.nombres.length == 0 || this.editedItem.apellidos.length == 0 || this.editedItem.codigo.length == 0)){
          bandera = false
          err = 'Debe ingresar los identificadores del usuario.'
        }

        if(bandera && (this.editedItem.cargo.length == 0 || this.editedItem.codigo_depto.length == 0 || this.editedItem.depto.length == 0)){
          bandera = false
          err = 'Debe ingresar los datos laborales'
        }
  
        if(bandera && (this.editedItem.grupo.length == 0 || this.editedItem.fono.length == 0 || this.editedItem.correo.length == 0)){
          bandera = false
          err = 'Debe ingresar los datos de contacto del usuario'
        }

        if(bandera && (this.editedItem.fecnacimiento.length == 0 || this.editedItem.fecingreso.length == 0 || this.editedItem.level.length == 0)){
          bandera = false
          err = 'Faltan datos importantes'
        }

      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },

    save() {
      if (this.editedIndex > -1) {
        let index = this.editedIndex
        Object.assign(this.datos[this.editedIndex], this.editedItem)
        axios
          .put(api.api + this.apiPath + '/admin', this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje)
            this.datos[index].sup = res.data.sup
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.editedItem.api = api.api
        axios
          .post(api.api + this.apiPath + '/admin', this.editedItem)
          .then(res => {
            res.data.fecingreso = moment(res.data.fecha_ingreso).format('L')
            res.data.fecnacimiento = moment(res.data.fecha_nacimiento).format('L')
            this.datos.push(res.data)
            this.toast(res.data.c, res.data.mensaje)      
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    
    deleteItem (item) {
      const index = this.datos.indexOf(item)
      swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {      
        if(ok){
          axios.delete(api.api + this.apiPath, {data: item})
          .then(res => {
            if(res.data.c=='success'){
              this.datos.splice(index, 1)
            }
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },

    restablecer(){
      axios
          .put(api.api + this.apiPath + '/reset/' + this.editedItem.id, this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      this.close()
    },

    cargaMasiva(){
     router.push('/masivo')
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },

    activate(id,estado){
      console.log(id,estado)
    },

    exportExcel(datosXLS) {
      let data = []
      for(let i=0;i<datosXLS.length;i++){
        let dtemp={
          codigo: datosXLS[i].codigo,
          cod_sup: 0,
          correo: datosXLS[i].correo,
          nombres: datosXLS[i].nombres,
          apellidos: datosXLS[i].apellidos,
          fecha_nacimiento: datosXLS[i].fecha_nacimiento,
          fecha_ingreso: datosXLS[i].fecha_ingreso,
          cargo: datosXLS[i].cargo,
          codigo_depto: datosXLS[i].codigo_depto,
          depto: datosXLS[i].depto,
          grupo: datosXLS[i].grupo,
          fono: datosXLS[i].fono,
        }
        data.push(dtemp)
      }
      let dataX = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      const filename = 'empleadosEvaluacion'
      XLSX.utils.book_append_sheet(workbook, dataX, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },    
  }
};
</script>